// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hweg","col":"styles_col__2VzJ1"};